"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentInformation = PaymentInformation;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
const loading_wrapper_1 = __importDefault(require("@src/components/modules/global/loading-wrapper"));
const Api = __importStar(require("@src/api"));
const types_1 = require("@src/types");
const PaymentInformationTable_1 = require("./PaymentInformationTable");
const StyledInfoAlert = (0, styled_components_1.default)(elements_1.Alert) `
	margin: 2.5rem 0;
	background-color: #e6f7ff;
	border: 1px solid #91d5ff;
	color: rgba(0, 0, 0, 0.85);
	.anticon {
		color: #1890ff;
	}
`;
function getProductIdFromInvoice(invoice) {
    if (!invoice) {
        return null;
    }
    if (invoice.company_payment_credit_id) {
        return types_1.ProductId.offerCredits;
    }
    if (invoice.company_payment_offer_promotion_id) {
        return types_1.ProductId.offerPromotion;
    }
    if (invoice.company_payment_subscription_id) {
        return types_1.ProductId.companyPremium;
    }
    throw new Error('Unknown product id');
}
function PaymentInformation({ invoiceId }) {
    const [isInitialized, setIsInitialized] = react_1.default.useState(false);
    const [invoice, setInvoice] = react_1.default.useState(null);
    const intl = (0, react_intl_1.useIntl)();
    const paymentInfo = {
        [types_1.PaymentInfoKeys.iban]: invoice === null || invoice === void 0 ? void 0 : invoice.iban,
        [types_1.PaymentInfoKeys.variable_symbol]: invoice === null || invoice === void 0 ? void 0 : invoice.variable_symbol,
        [types_1.PaymentInfoKeys.payment_due]: invoice === null || invoice === void 0 ? void 0 : invoice.payment_due,
        [types_1.PaymentInfoKeys.total_sum]: parseFloat(invoice === null || invoice === void 0 ? void 0 : invoice.amount_paid).toFixed(2),
    };
    const init = async () => {
        try {
            const invoiceResponse = await Api.Invoice.getInvoiceById(invoiceId);
            setInvoice(invoiceResponse);
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setIsInitialized(true);
        }
    };
    react_1.default.useEffect(() => {
        init();
    }, []);
    const getOrderMessage = () => {
        const productId = getProductIdFromInvoice(invoice);
        if (productId === types_1.ProductId.offerCredits) {
            return intl.formatMessage({ id: 'admin.payments.order_info.credits' });
        }
        if (productId === types_1.ProductId.offerPromotion) {
            return intl.formatMessage({ id: 'admin.payments.order_info.offer_promotion' });
        }
        if (productId === types_1.ProductId.companyPremium) {
            return intl.formatMessage({ id: 'admin.payments.order_info.subscription' });
        }
    };
    if (!invoice) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(elements_1.Panel, { children: (0, jsx_runtime_1.jsxs)(loading_wrapper_1.default, { isLoading: !isInitialized, children: [(0, jsx_runtime_1.jsx)("h2", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.order_number", values: {
                            orderNumber: invoice.number,
                        } }) }), (0, jsx_runtime_1.jsx)(StyledInfoAlert, { type: "info", showIcon: true, message: getOrderMessage() }), (0, jsx_runtime_1.jsx)(PaymentInformationTable_1.PaymentInformationTable, { paymentInfo: paymentInfo }), (0, jsx_runtime_1.jsx)("div", { className: "flex-center m-t-l", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "ghost", onClick: () => window.open(invoice.url, 'blank'), size: "middle", children: invoice.is_proforma ? ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.show_proforma" })) : ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.show_real_invoice" })) }) })] }) }));
}
